import { TST_BLESSED_ID_COLUMN_SELECTION } from "@impero-com/ui";
import {
    dateRangeCodec,
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export function buildTestingControlListTableStateStorageKey(
    testingProgramId: number
) {
    return `testingControlListForProgram-${testingProgramId}`;
}

export const TESTING_CONTROL_LIST_COLUMN_IDS = {
    NAME: "testName",
    ENTITIES_TO_TEST: "entitiesToTest",
    TAGS: "tags",
    ASSIGNED_TO: "assignedTo",
    DUE_DATE: "dueDate",
} as const;

export const testingControlListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: TESTING_CONTROL_LIST_COLUMN_IDS.NAME, desc: false }],
        columnOrder: [
            TST_BLESSED_ID_COLUMN_SELECTION,
            TESTING_CONTROL_LIST_COLUMN_IDS.NAME,
            TESTING_CONTROL_LIST_COLUMN_IDS.ENTITIES_TO_TEST,
            TESTING_CONTROL_LIST_COLUMN_IDS.TAGS,
            TESTING_CONTROL_LIST_COLUMN_IDS.ASSIGNED_TO,
            TESTING_CONTROL_LIST_COLUMN_IDS.DUE_DATE,
        ],
    };

export const testingControlListColumnFiltersCodecMap = {
    [TESTING_CONTROL_LIST_COLUMN_IDS.ENTITIES_TO_TEST]:
        withModeCodec(encodedArrayCodec),
    [TESTING_CONTROL_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
    [TESTING_CONTROL_LIST_COLUMN_IDS.ASSIGNED_TO]:
        withModeCodec(encodedArrayCodec),
    [TESTING_CONTROL_LIST_COLUMN_IDS.DUE_DATE]: withModeCodec(dateRangeCodec),
};
